import { useState } from "react";
import { Calendar, Clock, User } from "lucide-react";
import { resolveApiImageUrl } from "../../../utils/imageUrl";

const SessionCard = ({ session }) => {
  const [imageFailed, setImageFailed] = useState(false);
  const tutorName = session.tutorName || session.tutor || "Tutor";
  const imageSrc = imageFailed ? "" : resolveApiImageUrl(session.image);
  const avatarLetter = tutorName.charAt(0).toUpperCase() || "T";

  return (
    <div className="bg-white rounded-3xl shadow-sm border border-gray-200 p-8 flex items-center w-full">
      {imageSrc ? (
        <img
          src={imageSrc}
          alt={tutorName}
          className="w-40 h-40 rounded-3xl object-cover"
          onError={() => setImageFailed(true)}
        />
      ) : (
        <div className="w-40 h-40 rounded-3xl bg-[#eef3ff] text-[#2f4fd6] flex items-center justify-center text-5xl font-bold">
          {avatarLetter}
        </div>
      )}

      <div className="flex flex-col gap-3 ml-10 items-start">
        <div className=" flex flex-col">
          <div className="flex items-center gap-3">
            <p className="text-xl font-semibold text-gray-900">
              {tutorName}
            </p>

            <span className={`px-5 py-1.5 rounded-full text-sm font-medium ${
              session.status === "Upcoming" 
                ? "bg-green-50 text-green-600" 
                : "bg-gray-100 text-gray-600"
            }`}>
              {session.status}
            </span>
          </div>
        </div>

        <div className="flex items-center gap-10 justify-center">
          <div className="flex items-center gap-3">
            <Calendar size={20} strokeWidth={2} className="text-teal-500" />

            <div>
              <span className="text-gray-500 text-base">Date</span>
              <p className="text-lg font-normal text-gray-900">
                {session.date}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3 ml-20">
            <Clock size={20} strokeWidth={2} className="text-teal-500" />

            <div>
              <span className="text-gray-500 text-base">Time</span>
              <p className="text-lg font-normal text-gray-900">
                {session.time}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3 ml-20">
            <User size={20} strokeWidth={2} className="text-teal-500" />

            <div>
              <span className="text-gray-500 text-base">
                {session.personLabel || "Student"}
              </span>
              <p className="text-lg font-normal text-gray-900">
                {session.studentName || session.student}
              </p>
            </div>
          </div>
        </div>

        {session.status === "Upcoming" ? (
          <button className="px-6 py-2 bg-[#0000CC] text-white rounded-xl text-base font-semibold shadow-sm hover:bg-[#0000B3] transition">
            Join Session
          </button>
        ) : null}
      </div>
    </div>
  )
}

export default SessionCard
